/**
 * 判断文件是否为视频。
 */
export const isVideoFile = (file: File): boolean => (
  file.type.startsWith('video/') || /\.(mp4|mov|m4v)$/i.test(file.name)
);

/**
 * 判断文件是否为图片。
 */
export const isImageFile = (file: File): boolean => (
  file.type.startsWith('image/') || /\.(png|jpe?g|webp)$/i.test(file.name)
);
